import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Páginas "raiz" (home / entradas principais do menu) onde NÃO faz sentido ter "Voltar".
const ROOT_PATHS = ['/dashboard', '/leads', '/'];

export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (ROOT_PATHS.includes(location.pathname)) return null;

  const handleBack = () => {
    // idx > 0 garante que existe histórico para recuar; senão, volta à dashboard.
    const idx = window.history.state && typeof window.history.state.idx === 'number' ? window.history.state.idx : 0;
    if (idx > 0) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-[#2D3E6F] hover:bg-[#24325c] px-3 py-1.5 rounded-full mb-4 shadow-sm transition-colors"
      data-testid="global-back-btn"
    >
      <ArrowLeft className="w-4 h-4" /> Voltar
    </button>
  );
};

export default BackButton;
